import React, { FC } from 'react'
import { ContactFormValuesEnum } from '../types/contactFormValuesEnum'
import { Field } from 'react-final-form'
import { SelectOption } from '../../../types/fields/fieldsModel'
import { useIntl } from 'react-intl'
import { OriginContact } from '../types/originEnum'
import SelectField from '../../../components/fields/SelectField'

const OriginField: FC = () => {
	const intl = useIntl()

	const ORIGINS: SelectOption[] = [{
		label: intl.formatMessage({
			id: 'creationContact.origin.seLoger',
			defaultMessage: 'Se loger',
			description: 'Origin option'
		}),
		value: OriginContact.SE_LOGER
	}, {
		label: intl.formatMessage({
			id: 'creationContact.origin.bienIci',
			defaultMessage: 'Bien ici',
			description: 'Origin option'
		}),
		value: OriginContact.BIEN_ICI
	}, {
		label: intl.formatMessage({
			id: 'creationContact.origin.leBonCoin',
			defaultMessage: 'Le bon coin',
			description: 'Origin option'
		}),
		value: OriginContact.LE_BON_COIN
	}, {
		label: intl.formatMessage({
			id: 'creationContact.origin.panneau',
			defaultMessage: 'Panneau sur résidence',
			description: 'Origin option'
		}),
		value: OriginContact.PANNEAU_SUR_RESIDENCE
	}, {
		label: intl.formatMessage({
			id: 'creationContact.origin.relation',
			defaultMessage: 'Relation',
			description: 'Origin option'
		}),
		value: OriginContact.RELATION
	}, {
		label: intl.formatMessage({
			id: 'creationContact.origin.autre',
			defaultMessage: 'Autre',
			description: 'Origin option'
		}),
		value: OriginContact.AUTRE
	}]

	return (
		<Field
			name={ContactFormValuesEnum.ORIGIN}
			component={SelectField}
			label="creationContact.contactForm.origin"
			options={ORIGINS}
		/>
	)
}
export default OriginField